module.exports = __webpack_public_path__ + "img/ai3@2x.5d71b042.png";